/** Съвпадение с @db.VarChar в schema.prisma — надхвърлянето води до грешка в MySQL. */
export const BLOG_CATEGORY_NAME_MAX_LENGTH = 200;

export const BLOG_TITLE_MAX_LENGTH = 255;

export const BLOG_COVER_URL_MAX_LENGTH = 800;

export const BLOG_KEYWORDS_MAX_LENGTH = 500;

/** Slugify output cap (категории и кратки slug бази). */
export const BLOG_SLUGIFY_SLICE_LENGTH = 180;

/** Макс. дължина на slug на категория в БД (VARCHAR + collision). */
export const BLOG_CATEGORY_SLUG_MAX_LENGTH = 200;

/** Макс. дължина на входа за slug на статия преди уникалност. */
export const BLOG_POST_SLUG_SOURCE_MAX_LENGTH = 200;

/** Макс. дължина на slug на статия в БД (VARCHAR 220). */
export const BLOG_POST_SLUG_MAX_LENGTH = 220;

/** Excerpt и meta description — trim в API. */
export const BLOG_META_OR_EXCERPT_MAX_LENGTH = 320;

/** Макс. брой препоръчани статии/дестинации от админ (JSON масиви). */
export const BLOG_RECOMMENDED_POSTS_MAX = 12;

export const BLOG_RECOMMENDED_DESTINATIONS_MAX = 12;

/** Кратко описание в карта на списъка (символи). */
export const BLOG_LIST_EXCERPT_MAX_LENGTH = 200;

/** Резерв за „ … Прочети повече“ на един ред в картата на списъка (символи). */
export const BLOG_LIST_CARD_EXCERPT_RESERVE_CHARS = 32;

/**
 * По-къс excerpt в картата, за да остане място на последния ред за
 * „ … Прочети повече“ без да прескача на нов ред.
 */
export const BLOG_LIST_CARD_EXCERPT_MAX_LENGTH = Math.max(
  100,
  BLOG_LIST_EXCERPT_MAX_LENGTH - BLOG_LIST_CARD_EXCERPT_RESERVE_CHARS,
);

/** Горна граница на pageSize за публичен списък `/api/blog/posts`. */
export const BLOG_PUBLIC_LIST_MAX_PAGE_SIZE = 24;

/** Локален SVG за Next/Image, когато в БД липсва `coverImageUrl`. */
export const BLOG_COVER_PLACEHOLDER_SRC = '/images/placeholder-cover.svg';
